// extracted by mini-css-extract-plugin
module.exports = {"container":"shopHistoryStyles_container__UsQS3"};